import React from 'react';
import useCollapse from 'react-collapsed';
import styles from './collapsablePanel.module.css';
import { IoMdArrowDropright, IoMdArrowDropdown } from 'react-icons/io';

const CollapsablePanel = ({ index, title, data, startEnabled }) => {
    const { getCollapseProps, getToggleProps, isExpanded } = useCollapse({
        defaultExpanded: startEnabled,
        duration: 500
    });
    return (
        <div className={styles.session_container} key={`session${index}`}>
            <div className={styles.session_title_container} {...getToggleProps()}>
                {isExpanded ? (
                    <IoMdArrowDropdown size={'20px'} />
                ) : (
                    <IoMdArrowDropright size={'20px'} />
                )}

                <p>{title}</p>
            </div>
            <div className={styles.session_content} {...getCollapseProps()}>
                <p>{data}</p>
            </div>
        </div>
    );
};

export default CollapsablePanel;
